var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-screen h-screen flex flex-col items-center justify-center"},[_c('img',{staticClass:"animate-bounce w-20",attrs:{"src":"/img/rw/rw.png","alt":"online"}}),_c('h1',{staticClass:"text-4xl"},[_vm._v("Loading ...")])])
}]

export { render, staticRenderFns }